import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { fetchShowcase } from 'Catalog/Showcase/ducks'
import MediaQuery from 'react-responsive'

import { ProductCardContainer } from '../Availability/ProductCard'
import Showcase from './Showcase'

class ShowcaseContainer extends Component {
  componentDidMount () {
    const { loadShowcase, showcaseType, identifier } = this.props
    loadShowcase(showcaseType, identifier)
  }

  render () {
    const { loadShowcase: _, ...props } = this.props

    return (
      <Showcase {...props}>
        <MediaQuery minDeviceWidth={426}>
          {props.products.map(sku => <ProductCardContainer key={sku} sku={sku} />)}
        </MediaQuery>
        <MediaQuery maxDeviceWidth={425}>
          Limited 4 Product List
        </MediaQuery>
      </Showcase>
    )
  }
}

ShowcaseContainer.propTypes = {
  loadShowcase: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  showcaseType: PropTypes.string.isRequired,
  identifier: PropTypes.string.isRequired,
  products: PropTypes.array
}

ShowcaseContainer.defaultProps = {
  isLoading: true,
  products: []
}

const mapStateToProps = ({ showcases }, { showcaseType, identifier }) => {
  const showcase = showcases[showcaseType] ? showcases[showcaseType][identifier] : {}

  return showcase
}

const mapDispatchToProps = dispatch => ({
  loadShowcase: (showcaseType, identifier) => dispatch(fetchShowcase(showcaseType, identifier))
})

export default connect(mapStateToProps, mapDispatchToProps)(ShowcaseContainer)



// WEBPACK FOOTER //
// ./src/features/Showcase/ShowcaseContainer.js